// extracted by mini-css-extract-plugin
module.exports = {"counter":"upcomingCounter_counter__OOAhp","icon":"upcomingCounter_icon___MW1N","timeCell":"upcomingCounter_timeCell__8rVu4"};